import styled from 'styled-components';

const Form = styled.div``;

export { Form };
